import { MasterButton, Modal, InputTextArea } from "App/Component/ui";
import { Grid } from "@material-ui/core";
import React, { useContext, useState } from "react";
import { FormContext } from "../../context/FormContext";
import {
  defaultToastSuccess,
  defaultToastError,
  isNull,
  toUTCFormat,
} from "App/utils/helpers";
import { DISABLED_BUTTON_SUBMIT, instance4 } from "App/constants";
import {
  STATUS_TRANSAKSI_DRAFT,
  STATUS_TRANSAKSI_PENGAJUAN,
  STATUS_TRANSAKSI_DISETUJUI,
  STATUS_TRANSAKSI_PENAWARAN,
  STATUS_TRANSAKSI_TRIAL,
  STATUS_TRANSAKSI_PENGAJUAN_PO,
  STATUS_TRANSAKSI_PENGADAAN,
  STATUS_TRANSAKSI_REJECT,
  STATUS_TRANSAKSI_REVISI,
  STATUS_TRANSAKSI_SELESAI,
  urlCreateREQ,
  urlUpdateREQ,
  urlVerifikasiTransaksi,
} from "../../helpers";
import { useDispatchWrapper } from "hooks";
import { Alert } from "@material-ui/lab";

const SHOW_OPEN_DRAFT = {
  label: "OPEN DRAFT",
  color: "lightgreen",
  state: true,
  disabled: false,
};

export const SHOW_AJUKAN = {
  label: "PENGAJUAN",
  color: "lightgreen",
  state: true,
  disabled: false,
};

export const SHOW_DISETUJUI = {
  label: "SETUJUI",
  color: "green",
  state: true,
  disabled: false,
};

export const SHOW_PENGAJUAN_PO = {
  label: "PENGADAAN",
  color: "green",
  state: true,
  disabled: false,
};

export const SHOW_PENGADAAN = {
  label: "PENGADAAN",
  color: "green",
  state: true,
  disabled: false,
};

export const SHOW_TOLAK = {
  label: "TOLAK",
  color: "danger",
  state: true,
  disabled: false,
};

export const SHOW_UPDATE = {
  label: "UPDATE",
  color: "green",
  state: true,
  disabled: false,
};

export const SHOW_REVISI = {
  label: "REVISI",
  color: "warning",
  state: true,
  disabled: false,
};

export const SHOW_SELESAI = {
  label: "SELESAI",
  color: "green",
  state: true,
  disabled: false,
};

const ModalSimpan = ({
  setShowModal,
  setNewDataReqList,
  listREQ,
  setListREQ,
}) => {
  const [disabledOpenDraft, setDisabledOpenDraft] = useState(SHOW_OPEN_DRAFT);
  const [disabledUpdate, setDisabledUpdate] = useState(SHOW_UPDATE);
  const [disabledAjukan, setDisabledAjukan] = useState(SHOW_AJUKAN);
  const [disabledDisetujui, setDisabledDisetujui] = useState(SHOW_DISETUJUI);
  const [disabledTolak, setDisabledTolak] = useState(SHOW_TOLAK);
  const [disabledRevisi, setDisabledRevisi] = useState(SHOW_REVISI);
  const { validasi } = useContext(FormContext);

  const { state } = useDispatchWrapper();
  const code_menu = state.wrapper_active_tab;
  const menus = state.wrapper_tabs;
  const getMenu = menus.filter((e) => e.code === code_menu);

  const { formData, setFormData } = useContext(FormContext);
  const { setShowModalBarang } = useContext(FormContext);

  const handleClickOpenDraf = async (e) => {
    e.preventDefault();
    setDisabledOpenDraft(DISABLED_BUTTON_SUBMIT);
    try {
      if (
        formData.date === "" ||
        isNull(formData.nama) ||
        isNull(formData.unit_id) ||
        isNull(formData.status_kebutuhan) ||
        isNull(formData.user_request)
      ) {
        switch (true) {
          case isNull(formData.nama):
            defaultToastError("Harap lengkapi nama request !");
            setDisabledOpenDraft(SHOW_OPEN_DRAFT);
            setShowModal(false);
            break;
          case formData.date === "":
            defaultToastError("Harap pilih tanggal request !");
            setDisabledOpenDraft(SHOW_OPEN_DRAFT);
            setShowModal(false);
            break;
          case isNull(formData.unit_id):
            defaultToastError("Harap pilih unit anda !");
            setDisabledOpenDraft(SHOW_OPEN_DRAFT);
            setShowModal(false);
            break;
          case isNull(formData.user_request):
            defaultToastError("Username request dibutuhkan !");
            setDisabledOpenDraft(SHOW_OPEN_DRAFT);
            setShowModal(false);
            break;
          case isNull(formData.status_kebutuhan):
            defaultToastError("Harap pilih tingkat kebutuhan request !");
            setDisabledOpenDraft(SHOW_OPEN_DRAFT);
            setShowModal(false);
            break;
          default:
            defaultToastError("Harap lengkapi form request!");
            setDisabledOpenDraft(SHOW_OPEN_DRAFT);
            setShowModal(false);
            break;
        }
      } else {
        if (listREQ.length === 0) {
          defaultToastError("Harap isi data barang request terlebih dahulu !");
          setDisabledOpenDraft(SHOW_OPEN_DRAFT);
          setShowModal(false);
          setShowModalBarang(true);
        } else {
          const api = await instance4.post(urlCreateREQ, {
            name: formData.nama,
            status_kebutuhan: formData.status_kebutuhan,
            status: true,
            unit_id: formData.unit_id,
            remark: formData.remark,
            tgl_permintaan: toUTCFormat(formData.date),
            user_request: formData.user_request,
            detail: listREQ,
          });
          const res = await api?.data;
          if (res.status === 200) {
            setShowModal(false);
            defaultToastSuccess(res?.message);
            await setFormData({
              ...formData,
              idreq: res.data.id,
              isOpenDraf: true,
              isProcess: false,
            });
            await setListREQ(res.data.detail_req);
            setNewDataReqList(res.data.id);
          } else {
            setDisabledOpenDraft(SHOW_OPEN_DRAFT);
            defaultToastError(res?.message);
          }
        }
      }
    } catch (error) {
      setDisabledOpenDraft(SHOW_OPEN_DRAFT);
      defaultToastError(error?.response?.data?.message);
    }
  };

  const handleClickUpdate = async (e) => {
    e.preventDefault();
    setDisabledUpdate(DISABLED_BUTTON_SUBMIT);
    try {
      if (formData.date === "") {
        defaultToastError("Tanggal tidak boleh kosong!");
        setDisabledUpdate(SHOW_UPDATE);
      } else {
        const api = await instance4.post(urlUpdateREQ, {
          id: formData.idreq,
          name: formData.nama,
          status_kebutuhan: formData.status_kebutuhan,
          status: true,
          unit_id: formData.unit_id,
          remark: formData.remark,
          tgl_permintaan: toUTCFormat(formData.date),
          user_request: formData.user_request,
          detail: listREQ,
        });
        const res = await api?.data;
        if (res.status === 200) {
          setShowModal(false);
          await setListREQ(res.data.detail_req);
          defaultToastSuccess(res?.message);
          setNewDataReqList(formData.idreq);
        } else {
          defaultToastError(res?.message);
        }
        setDisabledUpdate(SHOW_UPDATE);
      }
    } catch (error) {
      setDisabledUpdate(SHOW_UPDATE);
      defaultToastError(error?.response?.data?.message);
    }
  };

  const handleClickAjukan = async (e) => {
    e.preventDefault();
    setDisabledAjukan(DISABLED_BUTTON_SUBMIT);
    try {
      if (formData.date === "") {
        defaultToastError("Tanggal tidak boleh kosong!");
        setDisabledAjukan(SHOW_AJUKAN);
      } else {
        const api = await instance4.post(urlVerifikasiTransaksi, {
          id: formData.idreq,
          status_verifikasi: STATUS_TRANSAKSI_PENGAJUAN,
          remak_verifikasi: formData.remak_verifikasi2,
          kode_menu: getMenu[0].code,
          nama_menu: getMenu[0].name,
        });
        const res = await api?.data;
        if (res.status === 200) {
          setShowModal(false);
          defaultToastSuccess(res?.message);
          await setFormData({
            ...formData,
            remark_verifikasi: formData.remak_verifikasi2,
            status_verifikasi: STATUS_TRANSAKSI_PENGAJUAN,
            isOpenDraf: false,
            isProcess: true,
          });
          setNewDataReqList(formData.idreq);
        } else {
          defaultToastError(res?.message);
        }
        setDisabledAjukan(SHOW_AJUKAN);
      }
    } catch (error) {
      setDisabledAjukan(SHOW_AJUKAN);
      defaultToastError(error?.response?.data?.message);
    }
  };

  const handleClickDisetujui = async (e) => {
    e.preventDefault();
    setDisabledDisetujui(DISABLED_BUTTON_SUBMIT);
    if (validasi) {
      try {
        if (formData.date === "") {
          defaultToastError("Tanggal tidak boleh kosong!");
          setDisabledDisetujui(SHOW_DISETUJUI);
        } else {
          const api = await instance4.post(urlVerifikasiTransaksi, {
            id: formData.idreq,
            status_verifikasi: STATUS_TRANSAKSI_DISETUJUI,
            remak_verifikasi: formData.remak_verifikasi2,
            kode_menu: getMenu[0].code,
            nama_menu: getMenu[0].name,
          });
          const res = await api?.data;
          if (res.status === 200) {
            setShowModal(false);
            defaultToastSuccess(res?.message);
            await setFormData({
              ...formData,
              remark_verifikasi: formData.remak_verifikasi2,
              status_verifikasi: STATUS_TRANSAKSI_DISETUJUI,
              isOpenDraf: false,
              isProcess: true,
            });
            setNewDataReqList(formData.idreq);
          } else {
            defaultToastError(res?.message);
          }
          setDisabledDisetujui(SHOW_DISETUJUI);
        }
      } catch (error) {
        setDisabledDisetujui(SHOW_DISETUJUI);
        defaultToastError(error?.response?.data?.message);
      }
    } else {
      setDisabledDisetujui(SHOW_DISETUJUI);
      defaultToastError("Anda tidak memiliki akses untuk menyetujui!");
    }
  };

  const handleClickTolak = async (e) => {
    e.preventDefault();
    setDisabledTolak(DISABLED_BUTTON_SUBMIT);
    if (validasi) {
      try {
        if (formData.date === "") {
          defaultToastError("Tanggal tidak boleh kosong!");
          setDisabledTolak(SHOW_TOLAK);
        } else {
          const api = await instance4.post(urlVerifikasiTransaksi, {
            id: formData.idreq,
            status_verifikasi: STATUS_TRANSAKSI_REJECT,
            remak_verifikasi: formData.remak_verifikasi2,
          });
          const res = await api?.data;
          if (res.status === 200) {
            setShowModal(false);
            defaultToastSuccess(res?.message);
            await setFormData({
              ...formData,
              remark_verifikasi: formData.remak_verifikasi2,
              status_verifikasi: STATUS_TRANSAKSI_REJECT,
              isOpenDraf: false,
              isProcess: true,
              kode_menu: getMenu[0].code,
              nama_menu: getMenu[0].name,
            });
            setNewDataReqList(formData.idreq);
          } else {
            defaultToastError(res?.message);
          }
          setDisabledTolak(SHOW_TOLAK);
        }
      } catch (error) {
        setDisabledTolak(SHOW_TOLAK);
        defaultToastError(error?.response?.data?.message);
      }
    } else {
      setDisabledTolak(SHOW_TOLAK);
      defaultToastError("Anda tidak memiliki akses untuk menolak permintaan!");
    }
  };

  const handleClickRevisi = async (e) => {
    e.preventDefault();
    setDisabledRevisi(DISABLED_BUTTON_SUBMIT);
    if (validasi) {
      try {
        if (formData.date === "") {
          defaultToastError("Tanggal tidak boleh kosong!");
          setDisabledRevisi(SHOW_REVISI);
        } else {
          const api = await instance4.post(urlVerifikasiTransaksi, {
            id: formData.idreq,
            status_verifikasi: STATUS_TRANSAKSI_REVISI,
            remak_verifikasi: formData.remak_verifikasi2,
            kode_menu: getMenu[0].code,
            nama_menu: getMenu[0].name,
          });
          const res = await api?.data;
          if (res.status === 200) {
            setShowModal(false);
            defaultToastSuccess(res?.message);
            await setFormData({
              ...formData,
              remark_verifikasi: formData.remak_verifikasi2,
              status_verifikasi: STATUS_TRANSAKSI_REVISI,
              isOpenDraf: true,
              isProcess: false,
            });
            setNewDataReqList(formData.idreq);
          } else {
            defaultToastError(res?.message);
          }
          setDisabledRevisi(SHOW_REVISI);
        }
      } catch (error) {
        setDisabledRevisi(SHOW_REVISI);
        defaultToastError(error?.response?.data?.message);
      }
    } else {
      setDisabledRevisi(SHOW_REVISI);
      defaultToastError("Anda tidak memiliki akses untuk merevisi permintaan!");
    }
  };

  const handleChange = (text) => (e) => {
    setFormData({
      ...formData,
      [text]: e.target.value,
    });
  };
  return (
    <Modal title={"Simpan"} show={setShowModal}>
      <Grid
        container
        direction="row"
        alignItems="center"
        style={{ marginBottom: "1rem" }}
      >
        {formData.status_verifikasi === STATUS_TRANSAKSI_PENGAJUAN ? (
          <InputTextArea
            id="remark_verifikasi"
            label={"Keterangan/Catatan"}
            name=""
            className="mt-1 w-full"
            value={formData.remak_verifikasi2}
            placeholder={""}
            onChange={handleChange("remak_verifikasi2")}
            rows={"3"}
          />
        ) : (
          <></>
        )}
        <ButtonCreate
          isOpenDraf={formData.isOpenDraf}
          formData={formData}
          disabledOpenDraft={disabledOpenDraft}
          disabledUpdate={disabledUpdate}
          disabledAjukan={disabledAjukan}
          disabledDisetujui={disabledDisetujui}
          disabledTolak={disabledTolak}
          disabledRevisi={disabledRevisi}
          handleClickOpenDraf={handleClickOpenDraf}
          handleClickUpdate={handleClickUpdate}
          handleClickAjukan={handleClickAjukan}
          handleClickDisetujui={handleClickDisetujui}
          handleClickTolak={handleClickTolak}
          handleClickRevisi={handleClickRevisi}
        />
      </Grid>
    </Modal>
  );
};

const ButtonCreate = ({
  isOpenDraf,
  formData,
  disabledOpenDraft,
  disabledUpdate,
  disabledAjukan,
  disabledDisetujui,
  disabledTolak,
  disabledRevisi,
  handleClickOpenDraf,
  handleClickUpdate,
  handleClickAjukan,
  handleClickDisetujui,
  handleClickTolak,
  handleClickRevisi,
}) => {
  return (
    <>
      {(isOpenDraf && !isNull(formData.idreq)) ||
      (!isOpenDraf && !isNull(formData.idreq)) ? (
        formData.status_verifikasi === STATUS_TRANSAKSI_PENGAJUAN ? (
          <>
            <MasterButton
              className={"mt-1 w-full text-center"}
              type={"button"}
              color={disabledDisetujui.color}
              onClick={(e) =>
                disabledDisetujui.disabled ? null : handleClickDisetujui(e)
              }
              name={disabledDisetujui.label}
              size="lg"
            />
            <MasterButton
              className={"mt-1 w-full text-center"}
              type={"button"}
              color={disabledRevisi.color}
              onClick={(e) =>
                disabledRevisi.disabled ? null : handleClickRevisi(e)
              }
              name={disabledRevisi.label}
              size="lg"
            />
            <MasterButton
              className={"mt-1 w-full text-center"}
              type={"button"}
              color={disabledTolak.color}
              onClick={(e) =>
                disabledTolak.disabled ? null : handleClickTolak(e)
              }
              name={disabledTolak.label}
              size="lg"
            />
          </>
        ) : formData.status_verifikasi === STATUS_TRANSAKSI_DRAFT ||
          formData.status_verifikasi === STATUS_TRANSAKSI_REVISI ? (
          <>
            <Alert severity="info" variant="outlined" style={{ width: "100%" }}>
              Harap lakukan update request ketika melakukan perubahan data
            </Alert>
            <MasterButton
              className={"mt-1 w-full text-center"}
              type={"button"}
              color={disabledUpdate.color}
              onClick={(e) =>
                disabledUpdate.disabled ? null : handleClickUpdate(e)
              }
              name={disabledUpdate.label}
              size="lg"
            />

            <MasterButton
              className={"mt-1 w-full text-center"}
              type={"button"}
              color={disabledAjukan.color}
              onClick={(e) =>
                disabledAjukan.disabled ? null : handleClickAjukan(e)
              }
              name={disabledAjukan.label}
              size="lg"
            />
          </>
        ) : formData.status_verifikasi === STATUS_TRANSAKSI_DISETUJUI ? (
          <>
            <div style={{ textAlign: "center", width: "100%" }}>
              <>TRANSAKSI SUDAH DISETUJUI OLEH MANAGER UNIT</>
            </div>
          </>
        ) : formData.status_verifikasi === STATUS_TRANSAKSI_PENAWARAN ? (
          <>
            <div style={{ textAlign: "center", width: "100%" }}>
              <>TRANSAKSI DALAM PROSES PENAWARAN HARGA</>
            </div>
          </>
        ) : formData.status_verifikasi === STATUS_TRANSAKSI_TRIAL ? (
          <>
            <div style={{ textAlign: "center", width: "100%" }}>
              <>TRANSAKSI DALAM PROSES TRIAL</>
            </div>
          </>
        ) : formData.status_verifikasi === STATUS_TRANSAKSI_PENGAJUAN_PO ? (
          <>
            <div style={{ textAlign: "center", width: "100%" }}>
              <>TRANSAKSI DALAM PROSES PENGAJUAN PO</>
            </div>
          </>
        ) : formData.status_verifikasi === STATUS_TRANSAKSI_PENGADAAN ? (
          <>
            <div style={{ textAlign: "center", width: "100%" }}>
              <>TRANSAKSI DALAM PROSES PURCHASE ORDER</>
            </div>
          </>
        ) : formData.status_verifikasi === STATUS_TRANSAKSI_SELESAI ? (
          <div style={{ textAlign: "center", width: "100%" }}>
            <>TRANSAKSI TELAH SELESAI</>
          </div>
        ) : (
          <div style={{ textAlign: "center", width: "100%" }}>
            <>TRANSAKSI DITOLAK</>
          </div>
        )
      ) : (
        <MasterButton
          className={"mt-1 w-full text-center"}
          type={"button"}
          color={disabledOpenDraft.color}
          name={disabledOpenDraft.label}
          onClick={(e) =>
            disabledOpenDraft.disabled ? null : handleClickOpenDraf(e)
          }
          size="lg"
        />
      )}
    </>
  );
};

export default ModalSimpan;
